module.exports = __webpack_public_path__ + "static/media/help-img-3-1.abfb6946.png";